const commands = [
  {
    name: '/assign',
    system_name: 'conversations.agents.attach',
    requiredParameters: true,
    description: 'Adds agent to conversation',
  },
  {
    name: '/assign_primary_agent',
    system_name: 'conversations.agents.attachprimary',
    description: 'Adds primary agent to conversation (ensure primary agent is set)',
  },
  {
    name: '/category',
    system_name: 'conversations.categories.attach',
    requiredParameters: true,
    description: 'Assign category to conversation',
  },
  {
    name: '/complete',
    system_name: 'conversations.close',
    description: 'Сomplete conversation',
  },
  {
    name: '/form',
    system_name: 'conversations.form.trigger',
    description: 'Trigger configured postchat form',
  },
  {
    name: '/lock',
    system_name: 'conversations.lock',
    requiredParameters: true,
    description: 'Locks conversation',
  },
  {
    name: '/lock_primary_agent',
    system_name: 'conversations.agents.lockprimary',
    requiredParameters: true,
    description: 'Locks primary agent to conversation',
  },
  {
    name: '/note',
    system_name: 'conversations.note.attach',
    requiredParameters: true,
    description: 'Adds note to conversation',
  },
  {
    name: '/send_agent_list',
    system_name: 'conversations.messages.agentlist',
    requiredParameters: true,
    description: 'Send agent selection list',
  },
  {
    name: '/star',
    system_name: 'conversations.star',
    requiredParameters: true,
    description: 'Adds conversation to watchlist',
  },
  {
    name: '/tag',
    system_name: 'conversations.tags.attach',
    requiredParameters: true,
    description: 'Assign tag to conversation',
  },
  {
    name: '/team',
    system_name: 'conversations.teams.attach',
    requiredParameters: true,
    description: 'Assign team to conversation',
  },
  {
    name: '/trigger_email_form',
    system_name: 'conversations.form.email',
    description: 'Trigger email form',
  },
  {
    name: '/unassign',
    system_name: 'conversations.agents.detach',
    requiredParameters: true,
    description: 'Removes agent from conversation',
  },
  {
    name: '/unlock',
    system_name: 'conversations.unlock',
    description: 'Unlocks conversation',
  },
  {
    name: '/unstar',
    system_name: 'conversations.unstar',
    requiredParameters: true,
    description: 'Removes conversation from watchlist',
  },
  {
    name: '/unteam',
    system_name: 'conversations.teams.detach',
    requiredParameters: true,
    description: 'Removes team from conversation',
  },
  {
    name: '/workflow',
    system_name: 'bot.workflow.init',
    requiredParameters: true,
    description: 'Run a selected workflow on conversation',
  },
  {
    name: '/enqueue',
    system_name: 'conversations.queue',
    description: 'Enqueue conversation',
  },
  {
    name: '/segment',
    system_name: 'customers.segments.attach',
    requiredParameters: true,
    description: 'Assign segment to customer',
  },
  {
    name: '/unsegment',
    system_name: 'customers.segments.detach',
    requiredParameters: true,
    description: 'Remove segment from customer',
  },
];
export default commands;